import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import SectionHeading from '../components/SectionHeading';
import { blogPosts, seoByRoute } from '../data/siteContent';
import { categoryColors } from '../config/theme';

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: (i = 1) => ({ opacity: 1, y: 0, transition: { delay: 0.08 * i, duration: 0.5 } }),
};

export default function Blog() {
  const seo = seoByRoute['/blog'];

  return (
    <>
      <SEO {...seo} />
      <section className="section pt-32">
        <SectionHeading
          as="h1"
          eyebrow="Insights"
          title="Stories from Sidama"
          description="Discover the innovations, community initiatives, and nutritional knowledge shaping Duoley's journey. New articles are published monthly with perspectives from our team and collaborators."
        />

        <div className="mt-16 grid gap-8 md:grid-cols-3">
          {blogPosts.map((post, index) => (
            <motion.article
              key={post.slug}
              className="flex h-full flex-col justify-between rounded-[28px] border border-slate-200 bg-gradient-to-br from-white to-slate-50 p-6 shadow-xl shadow-slate-200/70 hover:shadow-2xl hover:shadow-slate-300/70 transition-all duration-300 group"
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              custom={index}
              whileHover={{ y: -8 }}
            >
              <div>
                <div className={`inline-block rounded-full bg-gradient-to-br ${categoryColors[post.category] ?? categoryColors.default} px-3 py-1 text-xs uppercase tracking-[0.3em] font-semibold border`}>
                  {post.category}
                </div>
                <h2 className="mt-4 font-display text-xl text-text group-hover:text-primary transition-colors">{post.title}</h2>
                <p className="mt-3 text-sm leading-6 text-slate-600">{post.excerpt}</p>
              </div>
              <Link
                to="/contact"
                className="mt-6 inline-flex items-center gap-1 text-sm font-semibold text-primary transition-all hover:gap-2 hover:text-primary/80"
              >
                Continue the conversation →
              </Link>
            </motion.article>
          ))}
        </div>
      </section>

      <section className="mx-auto mt-32 max-w-5xl px-6">
        <motion.div
          className="rounded-[32px] bg-gradient-to-br from-primary to-primary/90 px-10 py-12 text-white relative overflow-hidden"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={fadeUp}
        >
          <div className="absolute top-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl -mr-48 -mt-48" />
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-secondary/10 rounded-full blur-3xl -ml-48 -mb-48" />

          <div className="relative z-10">
            <h2 className="font-display text-2xl text-white">Collaborate on a feature</h2>
            <p className="mt-3 text-sm text-white leading-relaxed">
              We welcome guest contributors, nutritionists, chefs, sustainability advocates, to share insights on building a
              resilient food system. Reach out to pitch your story or request a press kit.
            </p>
            <Link
              to="/contact"
              className="mt-6 inline-flex rounded-full bg-white px-6 py-3 text-xs font-semibold uppercase tracking-[0.35em] text-primary transition-all hover:bg-white/90 hover:shadow-lg"
            >
              Contact our media team
            </Link>
          </div>
        </motion.div>
      </section>
    </>
  );
}
